<template>
  <b-modal @hide="modalClose" ref="createModal" :title="$t('取引先グループ情報登録')" size="lg">
    <b-container fluid>
      <div class="border m-4 p-4 column">
        <div class="form-group">
          <p class="">{{ $t('取引先グループ名') }}:</p>
          <input v-model="form.name" type="text" class="form-control">
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-start mt-4 mb-4 w-95">
        <div class="d-flex">
          <button
            type="button"
            class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
            :disabled="registering"
            @click="register()"
          >
            <div
              class="d-flex justify-content-center align-items-center mr-3"
              v-if="registering"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
            {{ $t('登録') }}
          </button>
          <button
            type="button"
            class="btn btn-light"
            :disabled="registering"
            @click="modalClose()"
          >{{ $t('キャンセル') }}</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: {
        name: '',
        id: null,
      },
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(item) {
      this.$refs.createModal.show()
      if (item) {
        this.form.name = item.name
        this.form.id = item.id
      }
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.form = {
        name: '',
        id: null,
      }
      this.error = ''
      this.registering = false
      this.$refs.createModal.hide()
    },
    async register() {
      if (this.form.name === null || this.form.name === undefined) {
        this.error = this.$t('取引先グループ名') + this.$t('必須メッセージ')
        return
      } else {
        this.err = ''
      }
      this.registering = true
      let method = ''
      if (this.form.id) method = 'put'
      if (!this.form.id) method = 'post'
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (this.form[key]) params[key] = this.form[key]
      }
      try {
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/partner/group`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.modalClose()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show('データ登録エラーメッセージ')
      } finally {
        this.registering = false
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
